/**
 * @generated SignedSource<<9004392f3e29aafd689740a87f2cbfd4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Cleanliness = "BAD" | "GREAT" | "MEDIUM" | "%future added value";
export type CustomerSatisfaction = "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type HowTicketClosed = "NA" | "ON_SITE" | "REMOTE" | "%future added value";
export type Priority = "HIGH" | "HIGHEST" | "LOW" | "MEDIUM" | "%future added value";
export type ServiceType = "ON_SITE" | "REMOTE" | "%future added value";
export type StaffEnthusiasm = "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type Statuses = "ARCHIVED" | "COMPLETED" | "IN_PROCESS" | "ON_HOLD" | "PENDING" | "%future added value";
export type TicketHistoryAction = "ASSIGNEE_ADDED" | "ASSIGNEE_CHANGE" | "ASSIGNEE_REMOVED" | "CREATE" | "CREATE_SUB_TASK" | "DELETE" | "DELETE_SUB_TASK" | "JOB_STATUS_CHANGE" | "PRIORITY_CHANGE" | "STATUS_CHANGE" | "SUB_TASK_ASSIGNEE_CHANGE" | "SUB_TASK_PRIORITY_CHANGE" | "SUB_TASK_STATUS_CHANGE" | "TICKET_TYPE_CHANGE" | "UPDATE" | "UPDATE_SIGNATURE" | "UPDATE_SUB_TASK" | "%future added value";
export type TicketType = "LAB" | "MARKETING_OTHER" | "PREVENTIVE_MAINTANANCE" | "REACTIVE_MAINTANANCE" | "%future added value";
export type TrafficRate = "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type ViewTicket_getTicketQuery$variables = {
  id: string;
};
export type ViewTicket_getTicketQuery$data = {
  readonly getTicket: {
    readonly assignTo: {
      readonly firstName: string;
      readonly id: string;
      readonly lastName: string | null;
    } | null;
    readonly assignToId: string;
    readonly blender: {
      readonly id: string;
      readonly title: string;
    } | null;
    readonly blenderId: string | null;
    readonly board: {
      readonly id: string;
      readonly title: string;
    } | null;
    readonly boardId: string | null;
    readonly chatDescription: string | null;
    readonly cleanliness: Cleanliness | null;
    readonly closingDateAndTime: string | null;
    readonly comment: string | null;
    readonly createdAt: any;
    readonly createdBy: {
      readonly firstName: string;
      readonly id: string;
      readonly lastName: string | null;
    } | null;
    readonly createdById: string | null;
    readonly customerSatisfaction: CustomerSatisfaction | null;
    readonly diagnosisDone: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }> | null;
    readonly diagnosisOtherInput: string | null;
    readonly history: ReadonlyArray<{
      readonly action: TicketHistoryAction;
      readonly createdAt: any;
      readonly difference: string | null;
    }> | null;
    readonly howTicketClosed: HowTicketClosed | null;
    readonly id: string;
    readonly issueReportedOtherInput: string | null;
    readonly issueType: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly issueTypeId: string | null;
    readonly issuesReported: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }> | null;
    readonly lastAssigneToComment: string | null;
    readonly lastStatusComment: string | null;
    readonly machine: {
      readonly id: string;
      readonly location: {
        readonly latitude: string | null;
        readonly longitude: string | null;
      } | null;
      readonly locationId: string | null;
      readonly name: string | null;
      readonly serialNumber: string;
      readonly uuid: string | null;
    } | null;
    readonly machineId: string | null;
    readonly machineServiceOtherInput: string | null;
    readonly machineServices: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }> | null;
    readonly machineServicesDone: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }> | null;
    readonly marketingMaterials: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }> | null;
    readonly marketingOrOthers: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }> | null;
    readonly marketingOtherInput: string | null;
    readonly media: ReadonlyArray<{
      readonly type: string | null;
      readonly url: string | null;
    }> | null;
    readonly operationOtherInput: string | null;
    readonly operations: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }> | null;
    readonly operationsDone: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }> | null;
    readonly parentId: string | null;
    readonly priority: Priority;
    readonly replaceNewTubeDoors1mmShorter: boolean | null;
    readonly reportedAt: string | null;
    readonly reportedByEmail: string | null;
    readonly reportedById: string | null;
    readonly reportedByName: string | null;
    readonly reportedByPhone: string | null;
    readonly reportedByType: string | null;
    readonly reportedByUser: {
      readonly firstName: string;
      readonly lastName: string | null;
    } | null;
    readonly scheduleEndDate: any | null;
    readonly scheduleStartDate: any | null;
    readonly serviceType: ServiceType | null;
    readonly signatureImage: {
      readonly type: string | null;
      readonly url: string | null;
    } | null;
    readonly signatureName: string | null;
    readonly staffEnthusiasm: StaffEnthusiasm | null;
    readonly status: Statuses;
    readonly subTasks: ReadonlyArray<{
      readonly assignTo: {
        readonly firstName: string;
        readonly id: string;
        readonly lastName: string | null;
      } | null;
      readonly assignToId: string;
      readonly cleanliness: Cleanliness | null;
      readonly closingDateAndTime: string | null;
      readonly comment: string | null;
      readonly createdAt: any;
      readonly createdBy: {
        readonly firstName: string;
        readonly id: string;
        readonly lastName: string | null;
      } | null;
      readonly createdById: string | null;
      readonly customerSatisfaction: CustomerSatisfaction | null;
      readonly howTicketClosed: HowTicketClosed | null;
      readonly id: string;
      readonly issueReportedOtherInput: string | null;
      readonly issueType: {
        readonly id: string;
        readonly name: string;
      } | null;
      readonly issueTypeId: string | null;
      readonly lastAssigneToComment: string | null;
      readonly lastStatusComment: string | null;
      readonly machine: {
        readonly id: string;
        readonly locationId: string | null;
        readonly name: string | null;
        readonly serialNumber: string;
        readonly uuid: string | null;
      } | null;
      readonly machineId: string | null;
      readonly machineServiceOtherInput: string | null;
      readonly machineServices: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
      }> | null;
      readonly machineServicesDone: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
      }> | null;
      readonly marketingOrOthers: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
      }> | null;
      readonly marketingOtherInput: string | null;
      readonly media: ReadonlyArray<{
        readonly type: string | null;
        readonly url: string | null;
      }> | null;
      readonly operationOtherInput: string | null;
      readonly operations: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
      }> | null;
      readonly operationsDone: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
      }> | null;
      readonly parentId: string | null;
      readonly priority: Priority;
      readonly reportedAt: string | null;
      readonly serviceType: ServiceType | null;
      readonly staffEnthusiasm: StaffEnthusiasm | null;
      readonly status: Statuses;
      readonly ticketSource: {
        readonly id: string;
        readonly name: string;
      } | null;
      readonly ticketSourceId: string | null;
      readonly ticketType: TicketType | null;
      readonly timeSpentOnTask: number | null;
      readonly trafficRate: TrafficRate | null;
      readonly travelTime: string | null;
      readonly updatedAt: any | null;
      readonly updatedBy: {
        readonly firstName: string;
        readonly id: string;
        readonly lastName: string | null;
      } | null;
      readonly updatedById: string | null;
      readonly uuid: string | null;
    }> | null;
    readonly ticketSource: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly ticketSourceId: string | null;
    readonly ticketType: TicketType | null;
    readonly timeSpentOnTask: number | null;
    readonly trafficRate: TrafficRate | null;
    readonly travelTime: string | null;
    readonly travelingEndTime: any | null;
    readonly travelingStartTime: any | null;
    readonly updatedAt: any | null;
    readonly updatedBy: {
      readonly firstName: string;
      readonly id: string;
      readonly lastName: string | null;
    } | null;
    readonly updatedById: string | null;
    readonly uuid: string | null;
    readonly workStartTime: any | null;
  };
};
export type ViewTicket_getTicketQuery = {
  response: ViewTicket_getTicketQuery$data;
  variables: ViewTicket_getTicketQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ticketType",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "machineId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ticketSourceId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "issueReportedOtherInput",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "machineServiceOtherInput",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "operationOtherInput",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "marketingOtherInput",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reportedAt",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assignToId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "issueTypeId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priority",
  "storageKey": null
},
v15 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  },
  (v1/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v19 = [
  (v1/*: any*/),
  (v18/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueTypeObjectType",
  "kind": "LinkedField",
  "name": "issueType",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceType",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "MachineServiceObjectType",
  "kind": "LinkedField",
  "name": "machineServices",
  "plural": true,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "OperationObjectType",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "MachineServiceObjectType",
  "kind": "LinkedField",
  "name": "machineServicesDone",
  "plural": true,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "OperationObjectType",
  "kind": "LinkedField",
  "name": "operationsDone",
  "plural": true,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "MarketingObjectType",
  "kind": "LinkedField",
  "name": "marketingOrOthers",
  "plural": true,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "comment",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastStatusComment",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastAssigneToComment",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "howTicketClosed",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "closingDateAndTime",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeSpentOnTask",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "travelTime",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customerSatisfaction",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cleanliness",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "trafficRate",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "staffEnthusiasm",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdById",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedById",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v43 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  }
],
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "MediaDto",
  "kind": "LinkedField",
  "name": "media",
  "plural": true,
  "selections": (v43/*: any*/),
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serialNumber",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationId",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "TicketSourceObjectType",
  "kind": "LinkedField",
  "name": "ticketSource",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v48 = [
  (v1/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/)
],
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "UserObjectType",
  "kind": "LinkedField",
  "name": "assignTo",
  "plural": false,
  "selections": (v48/*: any*/),
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "UserObjectType",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": (v48/*: any*/),
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "UserObjectType",
  "kind": "LinkedField",
  "name": "updatedBy",
  "plural": false,
  "selections": (v48/*: any*/),
  "storageKey": null
},
v52 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "TicketObjectType",
    "kind": "LinkedField",
    "name": "getTicket",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reportedByType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reportedById",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reportedByName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reportedByPhone",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reportedByEmail",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "blenderId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "boardId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "scheduleStartDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "scheduleEndDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "travelingStartTime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "travelingEndTime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workStartTime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BoardObjectType",
        "kind": "LinkedField",
        "name": "board",
        "plural": false,
        "selections": (v15/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BlenderObjectType",
        "kind": "LinkedField",
        "name": "blender",
        "plural": false,
        "selections": (v15/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "replaceNewTubeDoors1mmShorter",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserObjectType",
        "kind": "LinkedField",
        "name": "reportedByUser",
        "plural": false,
        "selections": [
          (v16/*: any*/),
          (v17/*: any*/)
        ],
        "storageKey": null
      },
      (v20/*: any*/),
      (v21/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "IssueReportedObjectType",
        "kind": "LinkedField",
        "name": "issuesReported",
        "plural": true,
        "selections": (v19/*: any*/),
        "storageKey": null
      },
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "MarketingMaterialsObjectType",
        "kind": "LinkedField",
        "name": "marketingMaterials",
        "plural": true,
        "selections": (v19/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DiagnosisObjectType",
        "kind": "LinkedField",
        "name": "diagnosisDone",
        "plural": true,
        "selections": (v19/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "diagnosisOtherInput",
        "storageKey": null
      },
      (v27/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "chatDescription",
        "storageKey": null
      },
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      (v34/*: any*/),
      (v35/*: any*/),
      (v36/*: any*/),
      (v37/*: any*/),
      (v38/*: any*/),
      (v39/*: any*/),
      (v40/*: any*/),
      (v41/*: any*/),
      (v42/*: any*/),
      (v44/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "signatureName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MediaDto",
        "kind": "LinkedField",
        "name": "signatureImage",
        "plural": false,
        "selections": (v43/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MachineObjectType",
        "kind": "LinkedField",
        "name": "machine",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v45/*: any*/),
          (v18/*: any*/),
          (v46/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "LocationObjectType",
            "kind": "LinkedField",
            "name": "location",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "latitude",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "longitude",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v47/*: any*/),
      (v49/*: any*/),
      (v50/*: any*/),
      (v51/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "TicketHistoryObjectType",
        "kind": "LinkedField",
        "name": "history",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "action",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "difference",
            "storageKey": null
          },
          (v40/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TicketObjectType",
        "kind": "LinkedField",
        "name": "subTasks",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          (v26/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v27/*: any*/),
          (v28/*: any*/),
          (v29/*: any*/),
          (v30/*: any*/),
          (v31/*: any*/),
          (v32/*: any*/),
          (v33/*: any*/),
          (v34/*: any*/),
          (v35/*: any*/),
          (v36/*: any*/),
          (v37/*: any*/),
          (v38/*: any*/),
          (v39/*: any*/),
          (v40/*: any*/),
          (v41/*: any*/),
          (v42/*: any*/),
          (v44/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MachineObjectType",
            "kind": "LinkedField",
            "name": "machine",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v45/*: any*/),
              (v18/*: any*/),
              (v46/*: any*/)
            ],
            "storageKey": null
          },
          (v47/*: any*/),
          (v49/*: any*/),
          (v50/*: any*/),
          (v51/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ViewTicket_getTicketQuery",
    "selections": (v52/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ViewTicket_getTicketQuery",
    "selections": (v52/*: any*/)
  },
  "params": {
    "cacheID": "221e021f04d03692ba8e795e58dab1a6",
    "id": null,
    "metadata": {},
    "name": "ViewTicket_getTicketQuery",
    "operationKind": "query",
    "text": "query ViewTicket_getTicketQuery(\n  $id: String!\n) {\n  getTicket(id: $id) {\n    id\n    uuid\n    ticketType\n    machineId\n    parentId\n    ticketSourceId\n    issueReportedOtherInput\n    machineServiceOtherInput\n    operationOtherInput\n    marketingOtherInput\n    reportedAt\n    assignToId\n    issueTypeId\n    priority\n    reportedByType\n    reportedById\n    reportedByName\n    reportedByPhone\n    reportedByEmail\n    blenderId\n    boardId\n    scheduleStartDate\n    scheduleEndDate\n    travelingStartTime\n    travelingEndTime\n    workStartTime\n    board {\n      title\n      id\n    }\n    blender {\n      title\n      id\n    }\n    replaceNewTubeDoors1mmShorter\n    reportedByUser {\n      firstName\n      lastName\n    }\n    issueType {\n      id\n      name\n    }\n    serviceType\n    issuesReported {\n      id\n      name\n    }\n    machineServices {\n      id\n      name\n    }\n    operations {\n      id\n      name\n    }\n    machineServicesDone {\n      id\n      name\n    }\n    operationsDone {\n      id\n      name\n    }\n    marketingOrOthers {\n      id\n      name\n    }\n    marketingMaterials {\n      id\n      name\n    }\n    diagnosisDone {\n      id\n      name\n    }\n    diagnosisOtherInput\n    comment\n    chatDescription\n    lastStatusComment\n    lastAssigneToComment\n    status\n    howTicketClosed\n    closingDateAndTime\n    timeSpentOnTask\n    travelTime\n    customerSatisfaction\n    cleanliness\n    trafficRate\n    staffEnthusiasm\n    createdById\n    createdAt\n    updatedById\n    updatedAt\n    media {\n      url\n      type\n    }\n    signatureName\n    signatureImage {\n      url\n      type\n    }\n    machine {\n      id\n      uuid\n      serialNumber\n      name\n      locationId\n      location {\n        latitude\n        longitude\n      }\n    }\n    ticketSource {\n      id\n      name\n    }\n    assignTo {\n      id\n      firstName\n      lastName\n    }\n    createdBy {\n      id\n      firstName\n      lastName\n    }\n    updatedBy {\n      id\n      firstName\n      lastName\n    }\n    history {\n      action\n      difference\n      createdAt\n    }\n    subTasks {\n      id\n      uuid\n      ticketType\n      machineId\n      parentId\n      ticketSourceId\n      issueReportedOtherInput\n      machineServiceOtherInput\n      operationOtherInput\n      marketingOtherInput\n      reportedAt\n      assignToId\n      issueTypeId\n      priority\n      issueType {\n        id\n        name\n      }\n      serviceType\n      machineServices {\n        id\n        name\n      }\n      operations {\n        id\n        name\n      }\n      marketingOrOthers {\n        id\n        name\n      }\n      machineServicesDone {\n        id\n        name\n      }\n      operationsDone {\n        id\n        name\n      }\n      comment\n      lastStatusComment\n      lastAssigneToComment\n      status\n      howTicketClosed\n      closingDateAndTime\n      timeSpentOnTask\n      travelTime\n      customerSatisfaction\n      cleanliness\n      trafficRate\n      staffEnthusiasm\n      createdById\n      createdAt\n      updatedById\n      updatedAt\n      media {\n        url\n        type\n      }\n      machine {\n        id\n        uuid\n        serialNumber\n        name\n        locationId\n      }\n      ticketSource {\n        id\n        name\n      }\n      assignTo {\n        id\n        firstName\n        lastName\n      }\n      createdBy {\n        id\n        firstName\n        lastName\n      }\n      updatedBy {\n        id\n        firstName\n        lastName\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5212f467cdcb46506394895e9a9023b5";

export default node;
